"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNoopLogger = createNoopLogger;
class NoopLogger {
    isDebugEnabled() {
        return false;
    }
    debug() { }
    isInfoEnabled() {
        return false;
    }
    info() { }
    isWarnEnabled() {
        return false;
    }
    warn() { }
    isErrorEnabled() {
        return false;
    }
    error() { }
    child() {
        return new NoopLogger();
    }
}
function createNoopLogger() {
    return new NoopLogger();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xvZ2dlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQXNDQSw0Q0FFQztBQXhCRCxNQUFNLFVBQVU7SUFDZCxjQUFjO1FBQ1osT0FBTyxLQUFLLENBQUE7SUFDZCxDQUFDO0lBQ0QsS0FBSyxLQUFVLENBQUM7SUFDaEIsYUFBYTtRQUNYLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztJQUNELElBQUksS0FBVSxDQUFDO0lBQ2YsYUFBYTtRQUNYLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztJQUNELElBQUksS0FBVSxDQUFDO0lBQ2YsY0FBYztRQUNaLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztJQUNELEtBQUssS0FBVSxDQUFDO0lBQ2hCLEtBQUs7UUFDSCxPQUFPLElBQUksVUFBVSxFQUFFLENBQUE7SUFDekIsQ0FBQztDQUNGO0FBRUQsU0FBZ0IsZ0JBQWdCO0lBQzlCLE9BQU8sSUFBSSxVQUFVLEVBQUUsQ0FBQTtBQUN6QixDQUFDIn0=